
export default {
  name: 'YoutubeEmbedCodeGenerator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is it legal to embed any YouTube video on your website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. It is generally legal if you have obtained proper permission from the content creator or if it is available under a suitable Creative Commons license."
          }
        },
        {
          "@type": "Question",
          "name": "What is the difference between embedded code and links on YouTube?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Embedded code allows you to display the video player directly on your website. Meanwhile, links redirect users to the YouTube website to watch the video."
          }
        },
        {
          "@type": "Question",
          "name": "What does it mean to embed a video?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Embedding a video means adding the video player and the associated code to your website's HTML or content management system."
          }
        },
        {
          "@type": "Question",
          "name": "Does embedding YouTube videos slow down your website?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "They do not inherently slow down your website. But if you embed multiple videos or use large-sized videos, it can increase the loading time of your web pages."
          }
        },
        {
          "@type": "Question",
          "name": "Does YouTube pay for embedded videos?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "YouTube does not directly pay for embedded videos. YouTube's revenue model is from ads displayed on their platform. But content creators may earn through the YouTube Partner Program if ads are displayed on their videos, regardless of where they are embedded."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
          url: '',
          size_width: 560,
          size_height: 315,
          start_min: '',
          start_sec: '',
          end_min: '',
          end_sec: '',
          loop_video: false,
          auto_play_video: false,
          hide_full_screen_button: false,
          hide_player_controls: false,
          hide_youtube_logo: false,
          no_cookie: false,
          responsive: false
      })
    }
  },
  methods: {
    YoutubeEmbedCodeGenerator() {
        this.form.post(`/tool/youtube-embed-code-generator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.url = 'https://youtu.be/xN1WOlptE58';
    },
    onReset(){
        this.form.reset();
        this.data                    = null;
        this.url                     = '';
        this.size_width              = '';
        this.size_height             = '';
        this.start_min               = '';
        this.start_sec               = '';
        this.end_min                 = '';
        this.end_sec                 = '';
        this.loop_video              = false;
        this.auto_play_video         = false;
        this.hide_full_screen_button = false;
        this.hide_player_controls    = false;
        this.hide_youtube_logo       = false;
        this.no_cookie               = false;
        this.responsive              = false;
    },
    copyToClipboard() {
      document.getElementById("text").select();
      document.execCommand('copy');
    }
  }
}
